import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import { useHistory } from 'react-router-dom';
import { AddFileModal, FileHeader, Files } from '../components/InfoHub';

const InfoHub = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showEdit, setShowEdit] = useState(false);
    const [files, setFiles] = useState([]);

    const [addFileModal, setOpenAddFileModal] = useState(false);
    const handleAddFileModal = () => setOpenAddFileModal(!addFileModal);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Info Hub') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }

            const editPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('edit')) ||
                    (item.permissionName.includes('Info Hub') &&
                        item.permissionType.includes('edit'))
            );

            if (editPermit) {
                setShowEdit(true);
            }
        }
    }, [props.loginList]);

    useEffect(() => {
        const getFiles = async () => {
            const fileFromServer = await fetchFiles();
            setFiles(fileFromServer);
        };

        getFiles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch FileList
    const fetchFiles = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/infohub/getfile'
        );
        const data = await res.json();

        return data.FileList;
    };

    // Add File
    const addFile = async (file) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/infohub/addfile';
        const fileInfo = {
            categoryID: file.categoryID,
            fileName: file.fileName,
            fileLink: file.fileLink,
            fileType: file.fileType,
            fileSize: file.fileSize,
            employee: file.employee,
            entity: file.entity,
            createdBy: file.createdBy,
        };
        axios
            .post(url, fileInfo)
            .then(
                (response) => alert('File has been successfully created!'),
                setTimeout(() => {
                    setOpenAddFileModal(!addFileModal);
                }, 500),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const FileList = () => {
        return (
            <>
                {files.length > 0 ? (
                    <Files
                        files={files}
                        loginList={props.loginList}
                        badgeID={props.badgeID}
                        showEdit={showEdit}
                    />
                ) : (
                    <div style={{ marginTop: '20px', marginLeft: '10px' }}>
                        No file has been uploaded
                    </div>
                )}
            </>
        );
    };

    const history = useHistory();

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <FileHeader />
                        <div className='table-wrapper'>
                            <Button
                                onClick={() => history.push('/infohub/folder')}
                            >
                                View Folder List
                            </Button>
                            {showEdit && (
                                <Fragment>
                                    <Button onClick={handleAddFileModal}>
                                        Upload File
                                    </Button>
                                    <AddFileModal
                                        show={addFileModal}
                                        handleClose={handleAddFileModal}
                                        onAdd={addFile}
                                    />
                                </Fragment>
                            )}
                            <FileList />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default InfoHub;
